import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./AccountSelectorStyles";
import { accountActions } from "../_actions";

export default class AccountSelector extends Component {
  render() {
    const { account } = this.props;
    let hasElectricity =
      Object.keys(account.detail).length > 0 &&
      Object.keys(account.detail[0]).length > 0
        ? true
        : false;
    let hasAssisted =
      Object.keys(account.detail).length > 0 &&
      Object.keys(account.detail[1]).length > 0
        ? true
        : false;

    return (
      <div className={css(styles.selectorWrapper)}>
        {hasElectricity > 0 && (
          <span
            className={css(styles.selectorPanel)}
            onClick={() =>
              this.props.dispatch(accountActions.toggleTabs("energy"))
            }
          >
            <p
              className={css(
                styles.selector,
                account.accountTab === "energy" && styles.selected
              )}
            >
              HomeView
            </p>
          </span>
        )}
        {hasAssisted && (
          <span
            className={css(styles.selectorPanel)}
            onClick={() =>
              this.props.dispatch(accountActions.toggleTabs("assisted"))
            }
          >
            <p
              className={css(
                styles.selector,
                account.accountTab === "assisted" && styles.selected
              )}
            >
              InfoCare
            </p>
          </span>
        )}
        <span
          className={css(styles.selectorPanel)}
          onClick={() =>
            this.props.dispatch(accountActions.toggleTabs("settings"))
          }
        >
          <p
            className={css(
              styles.selector,
              account.accountTab === "settings" && styles.selected
            )}
          >
            Settings
          </p>
        </span>
      </div>
    );
  }
}
